import { cn } from "@/lib/utils";
import { useDocumentImage } from "../hook/use-document-image";
import { ConditionRenderer } from "@/components/shared/condition-renderer";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle, Loader } from "lucide-react";
import { IconRender } from "@/components/shared/Icon-render";
import { DocumentImageToolBar } from "./document-image-tool-bar";
type DocumentImageType = {
  className?: string;
  data: string[];
};
export const DocumentImage = ({ className, data }: DocumentImageType) => {
  const { state, setState } = useDocumentImage(data);

  const currentImage = state?.images?.[state.currentPage - 1];
  return (
    <div className={cn(className, "overflow-y-auto")}>
      {data ? (
        data?.length === 0 ? null : (
          <DocumentImageToolBar
            data={data}
            state={state}
            setState={setState}
            currentImage={currentImage}
          />
        )
      ) : null}

      <ConditionRenderer condition={data?.length !== 0 ? true : false}>
        <ConditionRenderer condition={state.loading ? true : false}>
          <div className="h-[200px] flex items-center justify-center">
            <Loader className="animate-spin transition-[1s]" size={30} />
          </div>
          <div className="p-5 relative ">
            <div className="border rounded-sm overflow-hidden relative flex items-center justify-center bg-white">
              <img
                src={currentImage || ""}
                onError={() => {
                  setState({ type: "error" });
                }}
              />
            </div>
            <ConditionRenderer
              condition={state.error && currentImage === undefined}
            >
              <div className="px-5 py-5 pr-0 absolute left-0 top-0 w-full">
                <Alert variant="destructive">
                  <AlertCircle className="h-4 w-4" />
                  <AlertTitle>Error</AlertTitle>
                  <AlertDescription className="break-words">
                    Image failed to load {state.imageUrl}
                  </AlertDescription>
                </Alert>
              </div>
            </ConditionRenderer>
          </div>
        </ConditionRenderer>

        <div className="pl-5 text-gray-500 pt-5 pb-5 h-full">
          <div className="bg-gray-50 gap-3 flex items-center justify-center h-full">
            <IconRender name="ImageOff" size={70} strokeWidth={3} />
            Image preview is not available
          </div>
        </div>
      </ConditionRenderer>
    </div>
  );
};
